module.exports = __webpack_public_path__ + "static/media/image4.135f32c0.jpg";